import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type {
  BorderProps,
  BorderTopProps,
  DisplayProps,
  HeightProps,
  SpaceProps,
  WidthProps,
} from 'styled-system';
import { border, borderTop, display, height, space, width } from 'styled-system';

import {
  borderTopColor,
  borderTopStyle,
  borderTopWidth,
  flexShrink,
  type BorderTopColorProps,
  type BorderTopStyleProps,
  type BorderTopWidthProps,
  type FlexShrinkProps,
} from '../theme/system-utilities';

const UnstyledSeparator = styled.hr<
  SpaceProps &
    HeightProps &
    BorderProps &
    BorderTopStyleProps &
    BorderTopWidthProps &
    BorderTopColorProps &
    BorderTopProps &
    DisplayProps &
    WidthProps &
    FlexShrinkProps & { 'data-testid'?: string }
>`
  ${space};
  ${height};
  ${border};
  ${borderTopStyle};
  ${borderTopWidth};
  ${borderTop};
  ${borderTopColor};
  ${display};
  ${width};
  ${flexShrink};
`;

const Separator = (props: ComponentProps<typeof UnstyledSeparator>) => (
  <UnstyledSeparator
    m="sp_0"
    border="none"
    aria-hidden="true"
    borderTopStyle="solid"
    borderTopWidth="small"
    data-testid="separator"
    borderTopColor="sys.neutral.border.weak"
    {...props}
  />
);

export default Separator;
